import React from 'react';
import { useTranslation } from 'react-i18next';
import Badge from './Badge';
import ListItem from './ListItem';

/* Reservation info summary block - used inside Card across:
   ReservationList, ReservationDetail, TransferComplete, TourComplete */
export default function ReservationSummary({
  service,
  serviceType, // 'transfer' | 'tour' | 'shopping' — Badge 컬러 결정용 (다국어 환경 대응)
  status,
  paymentDate,
  title,
  reservationNo,
  scheduledDate,
}) {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex items-center gap-2">
        <Badge variant="service" serviceType={serviceType}>{service}</Badge>
        {status && <Badge variant="status">{status}</Badge>}
      </div>
      <p className="text-sm text-mono-500">{paymentDate}</p>
      <h3 className="text-md font-bold text-mono-900">{title}</h3>
      <div>
        <ListItem label={t('common.reservation_number')} value={reservationNo} layout="inline" />
        {scheduledDate && (
          <ListItem label={t('common.scheduled_use_datetime')} value={scheduledDate} layout="inline" />
        )}
      </div>
    </>
  );
}
